import React from "react";
import "./style.css";
import { useTranslation } from "react-i18next";

const OurLocations = () => {

  // LOCATIONS GET
  const { t } = useTranslation("footer");
  const locations = t("locations", { returnObjects: true });

  return (
    <>
      <div className="our-locations-box-main">
        <div className="container">
          <div className="row">
            {locations?.map((item, index) => {
              return (
                <div
                  className="col-xl-3 col-lg-3 col-md-6 mb-3 space-bottom p-0"
                  key={index}
                >
                  <div className="location-card-box location-footer-cards text-left">
                    {/* <div className="location-icon">
                      <img src={`/images/address-icons/${item?.icon}`} />
                    </div> */}
                    {/* <h3></h3> */}
                    <h4 className="text-left d-block w-100">{item?.title} | {item?.location}</h4>
                    <a href={`${item?.addressLink || "#"}`} target="_blank">
                      {item?.address}
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default OurLocations;
